export default "__VITE_ASSET__wT5q9yx6__"